module.exports = __webpack_public_path__ + "static/aside.banner.girl-9604f05b1fdaf880f19409123f424c67.png";